import React from "react";
import Select from "react-select";
import Toaster from "toastr";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import Constants from "../../../configurations/constants";
import Messages from "../../../configurations/messages";
import Permissions from "../../../configurations/permissions";
import Util from "../../../util/util";
import ArbiterApi from "../../../api/ArbiterApi";
import Modal from "../../common/modal";
import CButton from "../../common/connectedButton";

class SettlementRulesModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isNew: props.isNew,
      isView: !props.isNew,
      isDelete: false,
      settlementRule: props.isNew ? {} : props.settlementRule,
      transactionTypes: [],
      transactionType: null,
      settlementRulesLabels: [],
      settlementRulesLabel: null,
      settlementType: null,
      title: props.isNew ? "New Settlement Rule" : `Settlement Rule`,
      updating: false,
      touchedForm: false,
      settlementRuleValidity: -1,
      transactionTypeValidity: -1,
      settlementTypeValidity: -1
    };

    this.modalStyle = {
      ovelay: {},
      content: {
        top: "80px",
        left: "250px",
        right: "250px",
        bottom: "100px",
        zIndex: "1000"
      }
    };
    this.onSettlementRulesChange = this.onSettlementRulesChange.bind(this);
    this.onTransactionTypeChange = this.onTransactionTypeChange.bind(this);
    this.onSettlementTypeChange = this.onSettlementTypeChange.bind(this);
  }

  onSettlementRulesChange(evt) {
    let settlementRule = Object.assign({}, this.state.settlementRule);
    settlementRule.ruleLabel = evt ? evt.value : null;

    this.setState({
      settlementRule,
      transactionType: evt,
      touchedForm: true,
      settlementRuleValidity: evt ? 1 : 0
    });
  }
  onTransactionTypeChange(evt) {
    let settlementRule = Object.assign({}, this.state.settlementRule);
    settlementRule.transactionType = evt ? evt.value : null;

    this.setState({
      settlementRule,
      transactionType: evt,
      touchedForm: true,
      transactionTypeValidity: evt ? 1 : 0
    });
  }

  onSettlementTypeChange(evt) {
    let settlementRule = Object.assign({}, this.state.settlementRule);
    settlementRule.settlementType = evt ? evt.value : null;
    this.setState({
      settlementRule,
      settlementType: evt,
      touchedForm: true,
      settlementTypeValidity: evt ? 1 : 0
    });
  }

  componentDidMount() {
    //Get Dispute Regions
    ArbiterApi.getTransactionTypes()
      .then(response => {
        let transactionTypes = response.data.content.map(obj => {
          obj.label = obj.name;
          obj.value = obj.name;
          return obj;
        });

        this.setState({ transactionTypes });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          ` ${Messages.ERROR_TRANSACTION_TYPES}`
        ]);
        console.log(error);
      });

    //Get Dispute Categories
    ArbiterApi.getSettlementRuleLabels()
      .then(response => {
        let settlementRulesLabels = response.data.map(obj => {
          let dropDownObject = {};
          dropDownObject.label = obj;
          dropDownObject.value = obj;
          return dropDownObject;
        });

        this.setState({ settlementRulesLabels });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_SETTLEMENT_RULES_LABEL}`,
          ""
        ]);
        console.log(error);
      });
  }

  handleAction(evt) {
    this.setState({ updating: true });

    const settlementRule = this.state.settlementRule;
    const isNew = this.state.isNew;
    let promise = this.state.isNew
      ? ArbiterApi.createSettlementRule(settlementRule)
      : ArbiterApi.updateSettlementRule(settlementRule.id, settlementRule);
    promise
      .then(response => {
        Toaster.success(
          `Settlement Rule successfully  ${isNew ? "created" : "updated"}`
        );
        this.setState({ updating: false });
        this.props.onRequestClose(evt, true);
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          `${error.data ? error.data.description : error.statusText}`,
          `${Messages.ERROR_SETTLEMENT_RULES_UPDATE} `
        ]);
        this.setState({ updating: false });
      });
  }

  handleDeleteAction(evt) {
    this.setState({ updating: true });
    const settlementRule = this.state.settlementRule;
    ArbiterApi.deleteSettlementRule(settlementRule.id)
      .then(response => {
        Toaster.success(Messages.SUCCESS_SETTLEMENT_RULE_DELETE);
        this.setState({ updating: false });
        this.props.onRequestClose(evt, true);
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          `${error.data ? error.data.description : error.statusText}`,
          `${Messages.ERROR_TRANSACTION_TIMELINES_DELETE} `
        ]);
        this.setState({ updating: false });
      });
  }

  render() {
    const isNew = this.state.isNew;
    const isView = this.state.isView;
    const isDelete = this.state.isDelete;
    return (
      <Modal
        title={this.state.title}
        isOpen={this.props.isOpen}
        style={this.modalStyle}
        onRequestClose={this.props.onRequestClose}
      >
        {isView && (
          <div className="mod-content">
            <form>
              <div className="row">
                <div className="col-md-11">
                  <div className="form-div">
                    <label>Settlement Rule:</label>
                    <label>{this.state.settlementRule.ruleLabel}</label>
                  </div>
                  <div className="form-div">
                    <label>Transaction Type:</label>
                    <label>{this.state.settlementRule.transactionType}</label>
                  </div>
                  <div className="form-div">
                    <label>Settlement Type:</label>
                    <label>{this.state.settlementRule.settlementType}</label>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}
        {!isView && (
          <div className="mod-content">
            <form>
              <div className="row">
                <div className="col-md-11">
                  <div className="form-div">
                    <label className="required">Settlement Rule</label>
                    <Select
                      id="settlementRule"
                      value={this.state.settlementRule.ruleLabel}
                      options={this.state.settlementRulesLabels}
                      onChange={this.onSettlementRulesChange}
                      placeholder="Select Settlement Rule"
                    />
                  </div>
                  <div className="form-div">
                    <label className="required">Transaction Type</label>
                    <Select
                      id="transactionType"
                      value={this.state.settlementRule.transactionType}
                      options={this.state.transactionTypes}
                      onChange={this.onTransactionTypeChange}
                      placeholder="Select Transaction Type"
                    />
                  </div>
                  <div className="form-div">
                    <label className="required">Settlement Type</label>
                    <Select
                      id="settlementType"
                      value={this.state.settlementRule.settlementType}
                      options={Constants.SETTLEMENT_TYPES}
                      onChange={this.onSettlementTypeChange}
                      placeholder="Select Settlement Type"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}
        {!isDelete && (
          <div className="mod-footer">
            <div className="mod-footer-buttons">
              {isView && (
                <CButton
                  onClick={evt => {
                    this.setState({ isView: false });
                  }}
                  className="btn btn-primary"
                  allowedPermissions={[Permissions.UPDATE_SETTLEMENT_RULE]}
                >
                  EDIT
                </CButton>
              )}
              {isView && (
                <CButton
                  onClick={evt => {
                    this.setState({ isDelete: true });
                  }}
                  className="btn btn-primary"
                  allowedPermissions={[Permissions.DELETE_SETTLEMENT_RULE]}
                >
                  DELETE
                </CButton>
              )}

              {!isView &&
                isNew && (
                  <CButton
                    onClick={evt => {
                      this.handleAction(evt);
                    }}
                    disabled={this.state.updating || !this.formValid()}
                    className="btn btn-primary"
                    allowedPermissions={[
                      Permissions.CREATE_SETTLEMENT_RULE
                    ]}
                  >
                    CREATE
                  </CButton>
                )}
              {!isView &&
                !isNew && (
                  <CButton
                    onClick={evt => {
                      this.handleAction(evt);
                    }}
                    disabled={this.state.updating || !this.formValid()}
                    className="btn btn-primary"
                    allowedPermissions={[
                      Permissions.UPDATE_SETTLEMENT_RULE
                    ]}
                  >
                    UPDATE
                  </CButton>
                )}

              <button
                onClick={evt => {
                  this.props.onRequestClose(evt);
                }}
                disabled={this.state.updating}
                className="btn btn-danger"
              >
                CLOSE
              </button>
            </div>
          </div>
        )}
        {isDelete && (
          <div className="mod-footer">
            <div className="action-warning">{Messages.ACTION_WARNING} ?</div>
            <div className="mod-footer-buttons">
              <button
                onClick={evt => {
                  this.setState({ isDelete: false });
                }}
                disabled={this.state.updating}
                className="btn btn-danger"
              >
                NO
              </button>
              <button
                onClick={evt => {
                  this.handleDeleteAction(evt);
                }}
                disabled={this.state.updating}
                className="btn btn-primary"
              >
                YES
              </button>
            </div>
          </div>
        )}
      </Modal>
    );
  }

  formValid() {
    if (this.state.isNew)
      //Each field must have an exact validity i.e. validity must exact equal '1'
      return (
        this.state.touchedForm &&
        this.state.settlementRuleValidity === 1 &&
        this.state.transactionTypeValidity === 1 &&
        this.state.settlementTypeValidity === 1
      );
    //all fields must be valid i.e validity must be 1 or -1 (for untouched fields)
    return (
      this.state.touchedForm &&
      this.state.settlementRuleValidity &&
      this.state.settlementTypeValidity &&
      this.state.transactionTypeValidity
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(SettlementRulesModal, [Permissions.VIEW_SETTLEMENT_RULE])
);



// WEBPACK FOOTER //
// ./src/components/settlement/settlementRules/settlementRulesModal.js